import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { routeNames } from 'src/app/app-routing-names';
import { AuthType } from 'src/app/models/enums/auth-type';
import { AuthenticationService } from '../services/authentication/authentication.service';

@Injectable({
    providedIn: 'root'
})
export class InternalAuthenticationGuard {
    constructor(private authenticationService: AuthenticationService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.isAllowedNavigate(state);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.canActivate(route, state);
    }

    async isAllowedNavigate(state: RouterStateSnapshot): Promise<boolean> {

        let hasValidAuth: boolean = false;
        const authType = this.authenticationService.getAuthType();

        if (authType === AuthType.Internal) {
            hasValidAuth = true;
        } else if (authType === AuthType.External) {
            this.router.navigate([routeNames.OWN_RENT_PROPERTY]);
        } else {
            this.router.navigate([routeNames.LOGIN], {
                queryParams: {
                    return: state.url
                }
            });
        }
        return of(hasValidAuth).toPromise();
    }
}
